import { Component, OnInit } from '@angular/core';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { environment } from 'src/environments/environment';

import { SeoService } from './services/seo.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {
  title = 'evaltrix';
  hideHeader = false;
  hidefooter: boolean = false;

  constructor(private router: Router, private seoService: SeoService) {
    let _this = this;
    // Set initial state based on current URL
    this.setHeaderVisibility();

    document.addEventListener("visibilitychange", function () {
      _this.setHeaderVisibility();
    });
  }

  ngOnInit(): void {
    this.seoService.init();
    // Ensure header visibility is set before child components initialize
    this.setHeaderVisibility();
    this.setupNavigationListener();
  }

  private setHeaderVisibility(): void {
    const currentUrl = this.router.url;
    if (currentUrl.includes('pendingAssessments')
      || currentUrl.includes('candidate')
      || currentUrl.includes('candidate-welcome')
      || currentUrl.includes('exam-question-view')
      || currentUrl.includes('submitted')) {
      this.hideHeader = true;
      this.hidefooter = true;
    } else {
      this.hideHeader = false;
      this.hidefooter = false;
    }
    // Ensure header is visible on verify pages as they are public pages
    if (currentUrl.includes('verify-entrepreneur')) {
      this.hideHeader = false;
      this.hidefooter = false;
    }
  }

  private setupNavigationListener(): void {
    this.router.events.forEach((event) => {
      if (event instanceof NavigationStart) {
        if (event.url.includes('pendingAssessments')
          || event.url.includes('candidate')
          || event.url.includes('candidate-welcome')
          || event.url.includes('exam-question-view')
          || event.url.includes('submitted')) {
          this.hideHeader = true;
          this.hidefooter = true;
        } else {
          this.hideHeader = false;
          this.hidefooter = false;
        }
        // Ensure header is visible on verify pages as they are public pages
        if (event.url.includes('verify-entrepreneur')) {
          this.hideHeader = false;
          this.hidefooter = false;
        }
      }
      // Ensure any navigation moves scroll to top of the main container
      if (event instanceof NavigationEnd) {
        try {
          const mainView = document.querySelector('.main-view') as HTMLElement;
          if (mainView && typeof mainView.scrollTo === 'function') {
            mainView.scrollTo({ top: 0, behavior: 'auto' });
          } else {
            window.scrollTo({ top: 0, behavior: 'auto' });
          }
        } catch {
          window.scrollTo(0, 0);
        }
      }
    });
  }

  onActivate(e, outlet) {
    setTimeout(() => {
      try {
        const mainView = document.querySelector('.main-view') as HTMLElement;
        if (mainView && typeof mainView.scrollTo === 'function') {
          mainView.scrollTo({ top: 0, behavior: 'auto' });
        } else {
          window.scrollTo({ top: 0, behavior: 'auto' });
        }
      } catch {
        window.scrollTo(0, 0);
      }
    }, 0);
  }
}
